// Captured words in both apps and automatic filing. Combining and filing
// captures preserve what the user typed or said.

import type { ItemKind } from './types/index.ts';

/** One capture from what was typed and then said: the typed text first, the words on the next line. */
export function combinedCapture(typed: string, spoken: string): string {
  const before = typed.trim();
  const words = spoken.trim();
  return before && words ? `${before}\n${words}` : before || words;
}

/** The text box once a capture that used `used` was saved: anything typed since stays. */
export function draftAfterSave(current: string, used: string): string {
  return current.startsWith(used) ? current.slice(used.length).trimStart() : current;
}

/** Captured words for a note's body or a task's notes; only a title-only task omits them. */
export function itemTextFromCapture(kind: ItemKind, rawText: string, title: string | null): string | null {
  const words = rawText.trim();
  const titleKey = (value: string) => value.trim().replace(/[\p{P}\s]+$/u, '').toLowerCase();
  return kind === 'task' && title !== null && titleKey(words) === titleKey(title) ? null : words;
}
